var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-ueditor-wrap',{attrs:{"config":_vm.myConfig,"destroy":true},on:{"beforeInit":_vm.addCustomButtom},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }